"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalanceIcon = BalanceIcon;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = require("react-jss");
const CoinIcon_1 = require("./CoinIcon");
const useStyles = (0, react_jss_1.createUseStyles)({
    wrapper: {
        display: "inline-flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "4px",
        letterSpacing: "2px",
        color: "#fff",
    },
});
function BalanceIcon({ amount, className }) {
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(classes.wrapper, className) },
        react_1.default.createElement("span", null, amount),
        react_1.default.createElement(CoinIcon_1.CoinIcon, null)));
}
